export type EffectivePlan = {
  slug: string;
  name: string;
  maxSearches?: number | null;
  remainingSearches?: number | null;
  maxSourcesPerSearch?: number | null;
  sourcesPerSearchUnlimited?: boolean;
  displayLabel: string;
  displayUsage: string;
};

export function renderMemberEffectivePlan(plan: EffectivePlan | null | undefined): {
  label: string;
  usage: string | null;
} {
  if (!plan) {
    return { label: '—', usage: null };
  }
  return {
    label: plan.displayLabel || plan.name,
    usage: plan.displayUsage || null,
  };
}
